var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShieldIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.2237 8.44678C24.5524 8.04288 23.7837 7.82947 23.0003 7.82947C22.2169 7.82947 21.4483 8.04288 20.777 8.44678L19.7861 9.04286C17.3849 10.4884 14.6894 11.3754 11.899 11.638L11.2761 11.6974C10.6823 11.7533 10.1306 12.0286 9.72903 12.4695C9.32743 12.9105 9.10474 13.4854 9.10449 14.0818V17.2328C9.10439 19.8689 9.6348 22.478 10.6641 24.9048C11.6935 27.3316 13.2007 29.5265 15.096 31.3586L21.3347 37.3904C21.7815 37.8225 22.3788 38.064 23.0003 38.064C23.6219 38.064 24.2191 37.8225 24.6659 37.3904L30.9047 31.3586C32.8 29.5265 34.3072 27.3316 35.3365 24.9048C36.3658 22.478 36.8963 19.8689 36.8962 17.2328V14.0818C36.8959 13.4854 36.6732 12.9105 36.2716 12.4695C35.87 12.0286 35.3184 11.7533 34.7246 11.6974L34.1017 11.6399C31.3111 11.3767 28.6156 10.4891 26.2146 9.04286L25.2237 8.44678Z",
    fill: "#AD4D34"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShieldIcon);
export default __webpack_public_path__ + "static/media/shieldIcon.1800cb5b780c4c6121608deb6f7e632f.svg";
export { ForwardRef as ReactComponent };